import * as React from 'react';
import { useRecoilValue } from 'recoil';
import TripsOverviewActions from '../TripsOverviewActions';
import ActionsMenu from './ActionsMenu';
import { ITripsOverViewRecord } from '../interfaces';
import { rideItemAtom } from '../TripsOverviewState';
import useAnalytics from '../../../hooks/useAnalytics';

export interface IActions {
  data: ITripsOverViewRecord;
  updateTable: () => void;
  datacyIndex: number;
  // openModalForm: (type: string, data: ITripsOverViewRecord) => void;
}

function Actions(props: IActions) {
  const [isActionsMenuOpened, setIsActionsMenuOpened] = React.useState(false);
  const rideItem = useRecoilValue(rideItemAtom(props.data ? String(props.data.id) : ''));
  const { trackEvent } = useAnalytics();

  const handleClickOutside = React.useCallback(
    (event: any) => {
      if (
        event.target.id !== `ride-${props.data.id}` &&
        event.target.id !== `rideActions-${props.data.id}`
      ) {
        setIsActionsMenuOpened(false);
      }
    },
    [props.data.id]
  );

  const handleEscapeKey = React.useCallback(
    (event: KeyboardEvent) => {
      if (event.code === 'Escape') {
        if (isActionsMenuOpened) {
          setIsActionsMenuOpened(false);
        }
      }
    },
    [isActionsMenuOpened]
  );

  React.useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    window.addEventListener('keydown', handleEscapeKey);
    return () => {
      window.removeEventListener('click', handleClickOutside);
      window.removeEventListener('keydown', handleEscapeKey);
    };
  }, [handleClickOutside, handleEscapeKey]);

  const handleActions = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setIsActionsMenuOpened(!isActionsMenuOpened);
    trackEvent(['ride book', 'click', `Ride book open single action menu: ${props.data.id}`]);
  };

  return (
    <div
      className="text-center align-middle sticky-col"
      style={{
        background: '#fff',
        zIndex: isActionsMenuOpened ? 10 : 4,
        minWidth: '60px',
        maxWidth: '60px',
        width: '60px',
      }}
    >
      <div className="dropdown actions" data-cy={`row-${props.datacyIndex + 1}-action`}>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <a
          href="#"
          className="text-gray-lighten"
          onClick={handleActions}
          style={{ padding: '15px', margin: '-15px' }}
          id={`rideActions-${props.data.id}`}
          data-cy="actions-menu-ride"
        >
          <i className="cmd-icons cmd-icon-more-horizontal fs-4" id={`ride-${props.data.id}`} />
        </a>
        {isActionsMenuOpened && rideItem && (
          <ActionsMenu
            data={rideItem}
            rideActions={TripsOverviewActions.getAllowedActions(rideItem)}
            parkingActions={TripsOverviewActions.getAllowedParkingActions(rideItem)}
            updateTable={props.updateTable}
            datacyIndex={0}
          />
        )}
      </div>
    </div>
  );
}

export default Actions;
